import React from 'react'

import Page from '../Page'
import ShortTextBlock from '../../ShortTextBlock'

const ShortTextPanel = ({
  id,
  panelColor,
  panelTexture,
  panelLabel,
  panelLabelColor,
  ...blockProps
}) => {
  return (
    <Page.Panel color={panelColor} texture={panelTexture} key={`panel${id}`}>
      {panelLabel && (
        <Page.Panel.Label color={panelLabelColor}>
          {panelLabel}
        </Page.Panel.Label>
      )}
      <ShortTextBlock {...blockProps} />
    </Page.Panel>
  )
}

export default ShortTextPanel
